/**
 * Created by karthikeyan.k on 30-11-2018.
 */
export class GameRNG {
  gametypeId: string;
  betlimit: number;
  rewriteURL: string;
  historyURL: string;
  sessiontoken: string;
  newtable: number;
  seat: number;
  gdt: number;
  initialusertype: string;
  gamename: string;
  lang: string;
  serverURL: string;
  flylogin: boolean;
  reloadURL: string;
  rchistoryurl: any;
  rciframeurl: any;
  rcinterval: any;
  rcelapsed: any;
  rcenable: any;
  homeurl?: any;
  fullscreen: string;
  roomid: string;
}
